import { render, staticRenderFns } from "./InstallationComplete.vue?vue&type=template&id=b840c378&"
import script from "./InstallationComplete.vue?vue&type=script&lang=js&"
export * from "./InstallationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b840c378')) {
      api.createRecord('b840c378', component.options)
    } else {
      api.reload('b840c378', component.options)
    }
    module.hot.accept("./InstallationComplete.vue?vue&type=template&id=b840c378&", function () {
      api.rerender('b840c378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Installer/InstallationComplete.vue"
export default component.exports